import axios from 'services/api';
import { API2_HOST } from '../helpers/urlHelper';

axios.defaults.withCredentials = true;
const url = `${API2_HOST}/employee-recognition`;

const searchEmployees = async (q, signal) => {
  const res = await axios({
    method: 'get',
    url: `${url}/employees${q ? `?search=${encodeURIComponent(q)}` : ''}`,
    signal
  });
  return res.data?.data ?? [];
};

const submitNomination = async ({ nomineeId, valueIds, demonstratedDate, reason }) => {
  const res = await axios({
    method: 'post',
    url: `${url}/nominations`,
    data: { nomineeId, valueIds, demonstratedDate, reason }
  });
  return res.data;
};

const getNominations = async (params = {}, signal) => {
  const query = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v != null))
  ).toString();
  const res = await axios({
    method: 'get',
    url: `${url}/nominations${query ? `?${query}` : ''}`,
    signal
  });
  return res.data?.data ?? { items: [], total: 0 };
};

const getAnalytics = async ({ from, to } = {}, signal) => {
  const query = new URLSearchParams(
    Object.fromEntries(Object.entries({ from, to }).filter(([, v]) => v))
  ).toString();
  const res = await axios({
    method: 'get',
    url: `${url}/nominations/analytics${query ? `?${query}` : ''}`,
    signal
  });
  return res.data?.data ?? {};
};

export { searchEmployees, submitNomination, getNominations, getAnalytics };
